<template>
  <section id="cloud" class="hp-cloud">
    <!-- 背景装饰 -->
    <div class="hp-cloud__deco">
      <div class="hp-cloud__deco-1"></div>
      <div class="hp-cloud__deco-2"></div>
    </div>

    <div class="hp-cloud__container">
      <!-- 标题 -->
      <div class="hp-cloud__head" data-aos="fade-up">
        <h2 class="hp-cloud__title">云业务 · 智能驱动未来</h2>
        <p class="hp-cloud__subtitle">五大云业务矩阵，覆盖零售全场景</p>
      </div>

      <!-- 零售云 - 全宽 -->
      <div class="hp-cloud__block" data-aos="fade-up">
        <div class="hp-cloud__panel">
          <div class="hp-cloud__panel-head">
            <LucideIcon name="shopping-cart" :size="20" />
            <h3>零售云</h3>
          </div>
          <div class="hp-cloud__grid is-3">
            <CloudCard v-for="(item, i) in cloudProducts[0].items" :key="i" :item="item" />
          </div>
        </div>
      </div>

      <!-- 分销云 + 会员云 -->
      <div class="hp-cloud__row" data-aos="fade-up">
        <div class="hp-cloud__col is-wide">
          <div class="hp-cloud__panel is-full">
            <div class="hp-cloud__panel-head">
              <LucideIcon name="network" :size="20" />
              <h3>分销云</h3>
            </div>
            <div class="hp-cloud__grid is-2">
              <CloudCard v-for="(item, i) in cloudProducts[1].items" :key="i" :item="item" />
            </div>
          </div>
        </div>
        <div class="hp-cloud__col">
          <div class="hp-cloud__panel is-full">
            <div class="hp-cloud__panel-head">
              <LucideIcon name="users" :size="20" />
              <h3>会员云</h3>
            </div>
            <div class="hp-cloud__grid is-1">
              <CloudCard v-for="(item, i) in cloudProducts[2].items" :key="i" :item="item" />
            </div>
          </div>
        </div>
      </div>

      <!-- 电商云 + 直播云 -->
      <div class="hp-cloud__row is-last" data-aos="fade-up">
        <div class="hp-cloud__col is-wide">
          <div class="hp-cloud__panel is-full">
            <div class="hp-cloud__panel-head">
              <LucideIcon name="shopping-bag" :size="20" />
              <h3>电商云</h3>
            </div>
            <div class="hp-cloud__grid is-2">
              <CloudCard v-for="(item, i) in cloudProducts[3].items" :key="i" :item="item" />
            </div>
          </div>
        </div>
        <div class="hp-cloud__col">
          <div class="hp-cloud__panel is-full">
            <div class="hp-cloud__panel-head">
              <LucideIcon name="video" :size="20" />
              <h3>直播云</h3>
            </div>
            <div class="hp-cloud__grid is-1">
              <CloudCard v-for="(item, i) in cloudProducts[4].items" :key="i" :item="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// 对应 projects-vue 的 src/components/sections/CloudSection.vue
import LucideIcon from '@/components/LucideIcon.vue'
import CloudCard from './CloudCard.vue'

// link 按 src/config/menu.js 里 cloudMenuConfig 的 target 映射到本项目实际路由
const CLOUD_PRODUCTS = [
  {
    category: '零售云',
    items: [
      {
        name: '千橙收银系统',
        desc: 'AI驱动半自动/自助收单，智能识别交易场景，提升收银效率与体验。',
        link: '/retailMall',
        icon: 'credit-card',
        color: '#2D6FF7'
      },
      {
        name: '千橙门店O2O系统',
        desc: 'AI赋能门店O2O一体化管理，智能匹配流量，高效协同线上线下业务。',
        link: '/onlineErp',
        icon: 'shopping-cart',
        color: '#2D6FF7'
      },
      {
        name: '千橙连锁系统',
        desc: 'AI赋能多业态连锁管理，智能数据分析预警，实现精细化运营管控。',
        link: '/onlineAndOfflineIntegration',
        icon: 'store',
        color: '#2D6FF7'
      }
    ]
  },
  {
    category: '分销云',
    items: [
      {
        name: '千橙S2B2C系统',
        desc: 'AI全链路闭环交易，智能撮合供需，自动化流转结算，助力产业协同。',
        link: '/integration',
        icon: 'network',
        color: '#2D6FF7'
      },
      {
        name: '千橙B2B系统',
        desc: 'AI驱动多层级分销，智能定价与库存预警，实现全流程数字化提效。',
        link: '/b2bChannel',
        icon: 'arrow-left-right',
        color: '#2D6FF7'
      }
    ]
  },
  {
    category: '会员云',
    items: [
      {
        name: '千橙会员营销系统',
        desc: '基于AI的会员SCRM，智能画像分群，个性化触达，提升全生命周期价值。',
        link: '/marketing',
        icon: 'gift',
        color: '#2D6FF7'
      }
    ]
  },
  {
    category: '电商云',
    items: [
      {
        name: '千橙微商城',
        desc: 'AI社群电商小程序，智能商品推荐，场景化营销，助力私域流量高效变现。',
        link: '/digitalSystem',
        icon: 'shopping-bag',
        color: '#F15A2E'
      },
      {
        name: '汇团团社群营销系统',
        desc: 'AI社群团购小程序，智能团长管理，自动化履约分佣，实现裂变增长。',
        link: '/scrmProduct',
        icon: 'message-circle',
        color: '#10B981'
      }
    ]
  },
  {
    category: '直播云',
    items: [
      {
        name: '千橙Qlive直播',
        desc: 'AI赋能直播系统，智能场控与数据复盘，优化流量转化，提升直播效能。',
        link: '/live',
        icon: 'radio',
        color: '#8B5CF6'
      }
    ]
  }
]

export default {
  name: 'CloudSection',
  components: { LucideIcon, CloudCard },
  data() {
    return {
      cloudProducts: CLOUD_PRODUCTS
    }
  }
}
</script>

<style lang="less" scoped>
@import './vars.less';

.hp-cloud {
  position: relative;
  .hp-section-padding();
  background: linear-gradient(to bottom, #ffffff 0%, #f6f8fc 50%, #ffffff 100%);
}

// 背景装饰
.hp-cloud__deco {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
}
.hp-cloud__deco-1 {
  position: absolute;
  top: 0;
  left: 25%;
  width: 500px;
  height: 500px;
  border-radius: 9999px;
  opacity: 0.03;
  filter: blur(64px);
  background: radial-gradient(circle, #2d6ff7 0%, transparent 70%);
}
.hp-cloud__deco-2 {
  position: absolute;
  bottom: 0;
  right: 25%;
  width: 400px;
  height: 400px;
  border-radius: 9999px;
  opacity: 0.03;
  filter: blur(64px);
  background: radial-gradient(circle, #0ecee6 0%, transparent 70%);
}

.hp-cloud__container {
  .hp-container();
  position: relative;
}

// 标题
.hp-cloud__head {
  text-align: center;
  margin-bottom: 48px;
}
.hp-cloud__title {
  .hp-section-title();
}
.hp-cloud__subtitle {
  .hp-section-subtitle();
  max-width: 672px;
}

// 分组容器
.hp-cloud__block {
  margin-bottom: 24px;
}
.hp-cloud__row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;

  &.is-last {
    margin-bottom: 0;
  }

  @media (min-width: @screen-lg) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.hp-cloud__col {
  @media (min-width: @screen-lg) {
    &.is-wide {
      grid-column: span 2 / span 2;
    }
  }
}

// 每个云的面板
.hp-cloud__panel {
  border-radius: 16px;
  background: linear-gradient(to bottom right, #f0f5ff, #f6f8fc);
  padding: 20px;
  text-align: left;

  &.is-full {
    height: 100%;
  }

  @media (min-width: @screen-lg) {
    padding: 24px;
  }
}
.hp-cloud__panel-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: @hp-blue;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: @hp-ink;
  }
}

// 卡片栅格
.hp-cloud__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  &.is-2 {
    @media (min-width: @screen-md) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  &.is-3 {
    @media (min-width: @screen-md) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
</style>
